import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    name: PropTypes.string.isRequired
};

function HelloServer({ name }) {
    return (
        <div className="hello">
            <div className="hello__greeting">Hello, {name}!</div>
            <div className="hello__description">This component was rendered on the server.</div>
        </div>
    );
}

HelloServer.propTypes = propTypes;

export default HelloServer;
